import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import { Router }from './routes.js';
import { RouterProvider } from 'react-router-dom';
import { Header } from './components/Header';
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={ Router }>
    </RouterProvider>
    <ToastContainer autoClose={3000}></ToastContainer>
  </React.StrictMode>
);


